<template>
  <div class="edit-import">
    <div class="node-container">
      <block-title class="block-title" title="流程状态" :show-line="false">
        <a-steps
          :current="current"
          direction="vertical"
          @change="onChange"
        >
          <a-step
            v-for="item in nodeList"
            :key="item.key"
            :title="item.title"
            :status="item.isDone ? 'finish' : 'wait'"
          >
            <template slot="icon">
              <a-icon v-if="item.isDone" class="dot-icon" :style="{fontSize: '12px'}" theme="filled" type="check-circle" />
              <div v-else class="detalt-dot" />
            </template>
          </a-step>
        </a-steps>
      </block-title>
    </div>
    <div ref="importBox" class="import-box" @scroll="handelScroll">
       <block-title v-if="isEnterprise" class="block-title"  title="所属服务商">
         <serviceSelect :disabled='isEdit' :is-default-select="true" :value="selectCustomer" class="carrier_title" @change="handleChange"></serviceSelect>
       </block-title>
      <template-info
        ref="templateInfo"
        :index="0"
        :form="form"
        @change="changeForm"
        @changeHeadRow="changeHeadRow"
      />
      <template-table
        ref="templateTable"
        :index="1"
        :form="form"
        :head-row="form.headRow"
        @change="changeForm"
        @changeList="changeList"
      />
      <destination-info
        ref="destinationInfo"
        :index="2"
        :form="form.startStation"
        :corresponding-list="form.headFields"
        @change="changeForm"
        @changeFiled="changeFiled('startStation')"
      />
      <receiving-info
        ref="receivingInfo"
        :index="3"
        :form="form.endStation"
        :corresponding-list="form.headFields"
        @change="changeForm"
        @changeFiled="changeFiled('endStation')"
      />
      <goods-info
        ref="goodsInfo"
        :index="4"
        :form="form.goods"
        :corresponding-list="form.headFields"
        @change="changeForm"
        @changeFiled="changeFiled('goods')"
      />
      <other-info
        ref="otherInfo"
        :form="form.others"
        :corresponding-list="form.headFields"
      />
    </div>
    <fix-bottom class="create-btns">
        <template slot="button">
            <a-button
              v-track-click="{ trackName: '自定义导入模板-取消' }"
              @click="handelCancel"
            >
              取消
            </a-button>
            <a-button
              v-track-click="{ trackName: '自定义导入模板-保存模版配置' }"
              type="primary"
              @click="onSubmit"
            >
              保存模版配置
            </a-button>
        </template>
    </fix-bottom>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import FixBottom from '@/components/fix-bottom/index.vue'
import moment from 'moment'
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue'
import TemplateInfo from './components/TemplateInfo.vue'
import TemplateTable from './components/TemplateTable.vue'
import DestinationInfo from './components/DestinationInfo.vue'
import ReceivingInfo from './components/ReceivingInfo.vue'
import GoodsInfo from './components/GoodsInfo.vue'
import OtherInfo from './components/OtherInfo.vue'
import { NODELIST, OTHERSVALUES } from './constant'
import { createTemplate, getTemplateDetail, updateTemplate } from '../api'

export default {
  name: 'EditCustomImport',
  components: {
    BlockTitle,
    TemplateInfo,
    TemplateTable,
    DestinationInfo,
    ReceivingInfo,
    GoodsInfo,
    OtherInfo,
    FixBottom,
    serviceSelect,
  },
  data() {
    return {
      current: 0,
      form: {
        fileName: '',
        fileUrl: '',
        isDefault: false, // 是否默认
        others: {
          ...OTHERSVALUES
        }, // 其他信息
        startStation: {
          importType: 'STATION_CODE',
        }, // 发货地站点信息
        endStation: {
          importType: 'STATION_CODE',
        }, // 收货地站点信息
        goods: {
          importType: 'GOODS_DETAIL',
        }, // 货品信息
        headFields: [], // 原始模板列表
      },
      nodeList: NODELIST,
      isCurrent: false,
      isEdit: false,
      code: null,
      selectCarrier:{},
      isEnterprise:false,
      selectCustomer:undefined,
    }
  },
  created() {
    const {code,customerCode} = this.$route.query
    if (code) {
      this.code = code
      this.isEdit = true
      this.getDetails(code)
    }
     const {customers,creditCode}=this.$store.state.user
    if(creditCode&&this.isEdit){
     this.selectCustomer= customers.filter(item=>item.customerCode===customerCode)[0].customerId
    }
    this.isEnterprise=!!this.$store.state.user.creditCode
  },
  methods: {
    handleChange(value){
     this.selectCarrier=value
    },
    changeFiled(type) {
      const { importType } = this.form[type]
      this.form[type] = {
        importType
      }
    },
    // 修改表头行
    changeHeadRow() {
      // 如果已经上传了文件，需要清除文件
      if (this.form.headFields.length) {
        this.$message.warning('切换表头所在行后需要重新上传文件')
        this.nodeList[1].isDone = false
        this.changeList(
          [], 
          {
            fileName: '',
            fileUrl: '',
          }
        )
      }
    },
    async getDetails(templateCode) {
      const res = await getTemplateDetail({
        templateCode,
      })
      // 编辑的页面所有的信息都是填写完成的，需要变更状态
      this.nodeList.map(node => {
        const item = node
        item.isDone = true
        return item
      })
      const { others, startStation, endStation } = res
      const { defaultStartTime } = startStation
      const { defaultEndTime } = endStation
      if (defaultStartTime) {
        res.startStation.defaultStartTime = moment(defaultStartTime)
      }
      if (defaultEndTime) {
        res.endStation.defaultEndTime = moment(defaultEndTime)
      }
      this.form = {
        ...res,
        headRow: `${res.headRow}`,
        isDefault: res.defaultTemplate,
        others: {
          ...others,
          defaultNeedShelves: others.defaultNeedShelves ? 'true' : 'false',
          defaultNeedHandling: others.defaultNeedHandling  ? 'true' : 'false',
          defaultNeedPickUp: others.defaultNeedPickUp ? 'true' : 'false',
          defaultIsLine: others.defaultIsLine ? 'true' : 'false',
        }
      }
    },
    // 切换流程
    onChange(current) {
      const {key} = this.nodeList[current]
      this.$refs[key].$el.scrollIntoView()
      this.current = current
      this.isCurrent = true
    },
    // 页面滚动时动态切换左侧的导航
    handelScroll() {
      if (this.isCurrent) {
        this.isCurrent = false
        return
      }
      const {scrollTop} = this.$refs.importBox
      const oneHeight = this.$refs.templateInfo.$el.offsetHeight
      const twoHeight = this.$refs.templateInfo.$el.offsetHeight + oneHeight
      const threeHeight = this.$refs.templateInfo.$el.offsetHeight + twoHeight
      const fourHeight = this.$refs.templateInfo.$el.offsetHeight + threeHeight
      const fiveHeight = this.$refs.templateInfo.$el.offsetHeight + fourHeight
      let current = 0
      if (scrollTop > fiveHeight) {
        current = 5
      } else if (scrollTop > fourHeight) {
        current = 4
      } else if (scrollTop > threeHeight) {
        current = 3
      } else if (scrollTop > twoHeight) {
        current = 2
      } else if (scrollTop > oneHeight) {
        current = 1
      }
      this.current = current
    },
    // 改变每项的完成状态
    changeForm(isDone, index) {
      this.nodeList[index].isDone = isDone
    },
    // 上传文件改变列表下拉
    changeList(list, fileParams) {
      this.form.headFields = list
      this.form.fileName = fileParams.fileName
      this.form.fileUrl = fileParams.fileUrl
      // 需要清空已选择的映射模板表头字段名称
      const { startStation, endStation, goods } = this.form
      this.form.others = OTHERSVALUES
      this.form.startStation = {
        importType: startStation.importType,
      }
      this.form.endStation = {
        importType: endStation.importType,
      }
      this.form.goods = {
        importType: goods.importType,
      }
      this.nodeList.forEach(item => {
        const {changeInfo} = this.$refs[item.key]
        if (changeInfo) {
          changeInfo(false)
        }
      })
    },
    handelCancel() {
      this.$router.push('/customImport')
    },
    async onSubmit() {
      const notDoneList = this.nodeList.filter(item => !item.isDone)
      if (notDoneList.length) {
        notDoneList.forEach(item => {
           this.$refs[item.key].getValidate()
        })
      } else {
        const form = JSON.parse(JSON.stringify(this.form))
        const params = {
          ...form,
          ...this.table,
        }
        const startTime = params.startStation.defaultStartTime
        if (startTime) {
          params.startStation.defaultStartTime = moment(startTime).valueOf()
        }
        const endTime = params.endStation.defaultEndTime
        if (endTime) {
          params.endStation.defaultEndTime = moment(endTime).valueOf()
        }
        let url = createTemplate
        if (this.isEdit) {
          params.templateCode = this.code
          url = updateTemplate
        }
        await url(params)
        this.$router.replace('/customImport')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.edit-import {
  display: flex;
  height: calc(100vh - 176px);
}
.node-container {
  background: #fff;
  width: 303px;
  border-radius: 6px;
  overflow-y: auto;
  /deep/ .ant-steps {
    .ant-steps-item-active {
      background: rgba(6,184,128, 0.2);
    }
    .ant-steps-item-container {
      margin-bottom: 24px;
      min-height: 40px;
      .ant-steps-item-icon {
        width: 12px;
        margin: 0 16px 0 32px;
        .ant-steps-icon {
          width: 12px;
          height: 40px;
          line-height: 40px;
          display: flex;
          align-items: center;
        }
      }
    }
    .ant-steps-item-content {
      min-height: 40px;
      cursor: pointer;
      .ant-steps-item-title {
        line-height: 40px;
        font-size: 14px;
        color: #171717;
      }
    }
    .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
      background: #DCDEE0;
      top: 26px;
      left: 38px;
      padding: 46px 0 6px;
    }
  }
  .dot-icon {
    width: 12px;
  }
  .detalt-dot {
    width: 12px;
    height: 12px;
    background: #171717;
    border-radius: 50%;
    margin: auto;
  }
}
.import-box {
  flex: 1;
  margin-left: 24px;
  background: #fff;
  border-radius: 4px;
  overflow-y: auto;
}
.create-btns {
  .align-right {
    .ant-btn {
      height: 48px;
      width: 120px;
      &.ant-btn-primary {
        width: 280px;
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.edit-import {
  .block-title {
    padding: 32px 0 24px 0;
  }
  .form-content {
    padding: 0 60px 0 32px;
    .ant-form-item-label {
      font-weight: 500;
    }
    .form-nomal {
      margin-bottom: 0;
    }
    &.choose-type {
      padding-bottom: 32px;
    }
  }
}
.carrier_title {
  margin-left: 24px;
  .severs_select{
    min-width: 350px !important;
  }
  
}

</style>